module.exports = __webpack_public_path__ + "img/erweima1.f8b9075.png";